<template>
  <p>
    <strong class="text-purple-ap-100 uppercase font-black"
      >{{ auPairAge }}
    </strong>
    Years Old
  </p>
</template>

<script>
export default {
  name: "Age",
  props: ["age"],
  computed: {
    auPairAge() {
      let birthYear = new Date(this.age).getFullYear();
      let currentYear = new Date().getFullYear();
      return currentYear - birthYear;
    },
  },
};
</script>
